<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        <span>{{ 'quoteTracking.quoteStatus' | cxTranslate }}</span>
      </div>
    </div>
    <div class="cx-dialog-body modal-body">
      <div *ngIf="!warningMsg">
        {{ 'quoteTracking.saveCart' | cxTranslate }}
      </div>
      <div *ngIf="warningMsg">
        {{ 'quoteTracking.qtyZero' | cxTranslate }}
        <!-- you can deselect the line item with zero quantity from the cart and proceed for Order conversion. -->
      </div>
      <div class="row mt-30">
        <div class="col-sm-12 col-md-12 action-container">
          <button cxAutoFocus class="vs-text-btn" (click)="closeModal('close')">
            {{ 'quoteTracking.cancel' | cxTranslate }}
          </button>
          <button class="vs-primary-btn" (click)="closeModal('accept-quote')">
            {{ 'quoteTracking.proceed' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
